export default class MatchMedia {
    constructor() 
    {
        // Setup
        this.mobile = window.matchMedia("(max-width: 950px)");
        this.tablet = window.matchMedia("(min-width: 951px) and (max-width: 1600px)");
        this.desktop = window.matchMedia("(min-width: 1601px)");
    }
}